// base/utils.js (your current file)

export const NumberUtils = {
  isEven: (num) => {
    const number = Number(num);
    return !isNaN(number) && Number.isInteger(number) && number % 2 === 0;
  },
};

export const ArrayUtils = {
  sortBy: (array, property, direction = "asc") => {
    return [...array].sort((a, b) => {
      let aVal = property ? a[property] : a;
      let bVal = property ? b[property] : b;

      if (typeof aVal === "string") {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }

      if (direction === "desc") {
        return bVal > aVal ? 1 : bVal < aVal ? -1 : 0;
      }
      return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
    });
  },
};

export const isEmptyString = (value) => {
  return value == "";
};

export const isNullOrUndefined = (value) => {
  return value == null || value == undefined;
};

export const isNullOrUndefinedOrEmpty = (value) => {
  return value == null || value == undefined || value == "";
};

export const isNumber = (value) => {
  return typeof value === "number" && value !== NaN && value !== "e";
};

export const isString = (value) => {
  return typeof value === "string";
};

export const createSlug = (text = "") => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const createRecipeSlug = (recipe) => {
  if (!recipe) return "";

  const nameSlug = createSlug(recipe.recipe_name);
  const shortId = recipe.id?.split("-")[0];

  return nameSlug && shortId ? `${nameSlug}-${shortId}` : "";
};

// Export individual functions
export const { isEven } = NumberUtils;
export const { sortBy } = ArrayUtils;
